import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import GrievanceRedressal from "./pages/GrievanceRedressal";

function App() {
  return (
    <div style={{ overflowX: "hidden" }}>
      <Router>
        <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route exact path="/terms" element={<TermsAndConditions />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            exact
            path="/Grievance-Redressal-Policy"
            element={<GrievanceRedressal />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
